(function() { module.exports = window["n2p-ui-library"]; }());